import { render, staticRenderFns } from "./detail-share.vue?vue&type=template&id=ab689578"
import script from "./detail-share.vue?vue&type=script&lang=js"
export * from "./detail-share.vue?vue&type=script&lang=js"
import style0 from "./detail-share.vue?vue&type=style&index=0&id=ab689578&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports